import { GET_ORG_VENUE_STORES } from '@/libs/onboarding/queries';
import { useLazyQuery } from '@apollo/client/react/hooks';

export const useVenues = () => {
  const [refetch, { data, loading, error }] = useLazyQuery(
    GET_ORG_VENUE_STORES,
    {
      fetchPolicy: 'no-cache',
    },
  );

  return {
    venues: data?.venues || [],
    loading,
    error,
    fetchVenues: refetch,
  };
};
